import { render, staticRenderFns } from "./manchestore-banner.vue?vue&type=template&id=225abe83&scoped=true&"
import script from "./manchestore-banner.vue?vue&type=script&lang=js&"
export * from "./manchestore-banner.vue?vue&type=script&lang=js&"
import style0 from "./manchestore-banner.vue?vue&type=style&index=0&id=225abe83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225abe83",
  null
  
)

export default component.exports